<template>
    <div class="fixed top-0 left-0 bg-gray-900 bg-opacity-75 w-full h-full flex justify-center gap-2" id="lightboxExpanded" ref="lightbox" @click="hide"
         style="z-index: 901">

        <div class="flex flex-col justify-between p-2 gap-2" @click.stop="">
            <div class="flex justify-center items-center h-full">
                <vue-photo-zoom-pro :url="images[currentIndex]" :high-url="images[currentIndex]"
                                    :height="zoomHeight" :width="zoomWidth"
                                    class="flex h-auto w-auto"
                                    :scale="zoomScale" ref="vuePhotoZoomObject">
                </vue-photo-zoom-pro>
            </div>

            <div class="flex items-center justify-center gap-6 w-full" @click.stop="">
                <button @click.stop.prevent="first" class="text-white hover:bg-gray-200 transform rotate-90 hover:text-indigo-600 transition duration-300 p-1 rounded-md">
                    <icon-chevron-down-double :class="notSmallScreen ? 'w-4 h-4' : 'w-6 h-6'"></icon-chevron-down-double>
                </button>

                <button @click.stop.prevent="prev"
                        class="text-white hover:bg-gray-200 transform rotate-180  hover:text-indigo-600 transition duration-300 p-1 rounded-md">
                    <icon-chevron-right :class="notSmallScreen ? 'w-4 h-4' : 'w-6 h-6'"></icon-chevron-right>
                </button>

                <simple-dropdown :label="zoomLabel">
                    <template slot="buttonOptions">
                        <simple-dropdown-option @click="changeZoomLevel(2)" value="2x">
                            2x
                        </simple-dropdown-option>

                        <simple-dropdown-option @click="changeZoomLevel(3)" value="3x">
                            3x
                        </simple-dropdown-option>

                        <simple-dropdown-option @click="changeZoomLevel(4)" value="4x">
                            4x
                        </simple-dropdown-option>

                        <simple-dropdown-option @click="changeZoomLevel(5)" value="5x">
                            5x
                        </simple-dropdown-option>
                    </template>
                </simple-dropdown>

                <button class="rounded-md border border-gray-300 shadow-sm p-2 bg-white font-normal text-gray-700 hover:bg-indigo-50 hover:border-indigo-300 hover:text-indigo-600 focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-600" @click="hide()">
                    Close
                </button>

                <button @click.stop.prevent="next" class="text-white hover:bg-gray-200 hover:text-indigo-600 transition duration-300 p-1 rounded-md">
                    <icon-chevron-right :class="notSmallScreen ? 'w-4 h-4' : 'w-6 h-6'"></icon-chevron-right>
                </button>

                <button @click.stop.prevent="last" class="text-white hover:bg-gray-200 transform rotate-90  hover:text-indigo-600 transition duration-300 p-1 rounded-md">
                    <icon-chevron-up-double :class="notSmallScreen ? 'w-4 h-4' : 'w-6 h-6'"></icon-chevron-up-double>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import vuePhotoZoomPro from "vue-photo-zoom-pro";
import "vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css";

export default {
    components: {vuePhotoZoomPro},

    props: [
        "show",
        "images",
        "selectedIndex",
    ],

    data () {
        return {
            currentIndex: -1,
            isMounted: false,
            lightboxElement: null,
            zoomWidth: 250,
            zoomHeight: 250,
            zoomScale: 2,
        };
    },

    mounted () {
        this.currentIndex = this.selectedIndex && this.selectedIndex > -1 ? this.selectedIndex : 0;
        document.documentElement.style.overflow = 'hidden';
        window.addEventListener("keydown", this.eventListener);
    },

    beforeDestroy () {
        // Remove overflow 'hidden'
        document.documentElement.style.overflow = ''
        window.removeEventListener("keydown", this.eventListener);
    },

    computed: {
        hasPrev () {
            return (this.currentIndex - 1) >= 0;
        },
        hasNext () {
            return (this.currentIndex + 1) < this.images?.length;
        },
        zoomLabel () {
            return `${this.zoomScale}x Zoom`;
        },
    },

    methods: {
        hide () {
            this.$emit("close");
            this.currentIndex = -1;
        },

        first () {
            this.currentIndex = 0;
        },

        prev () {
            if (this.hasPrev) {
                this.currentIndex -= 1;
            } else {
                this.last();
            }
        },

        next () {
            if (this.hasNext) {
                this.currentIndex += 1;
            } else {
                this.first();
            }
        },

        last () {
            this.currentIndex = this.images.length - 1;
        },

        changeZoomLevel (zoomLevel) {
            this.zoomScale = zoomLevel;
        },

        eventListener (e) {
            if (this.show) {
                switch (e.key) {
                    case "ArrowRight":
                        this.next();
                        break;
                    case "ArrowLeft":
                        this.prev();
                        break;
                    case "ArrowDown":
                    case "ArrowUp":
                        e.preventDefault();
                        break;
                    case "Escape":
                        this.hide();
                        break;
                }
            }
        },
    },
};
</script>

<style>
.vue-photo-zoom-pro img {
    object-fit: scale-down;
    max-height: calc(100vh - 62px);
}
</style>